module.exports = __webpack_public_path__ + "img/Man.6ef0bf4a.svg";